import AntIcon from '@ant-design/icons'
import { FC } from 'react'

export const LinkIcon: FC = () => (
    <AntIcon
        component={() => (
            <svg
                width="21"
                height="28"
                viewBox="0 0 21 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M19.6 0H1.4C0.626801 0 0 0.626801 0 1.4V26.6C0 27.3732 0.626801 28 1.4 28H19.6C20.3732 28 21 27.3732 21 26.6V1.4C21 0.626801 20.3732 0 19.6 0Z"
                    fill="#5099ff"
                />

                <text
                    x="10.5"
                    y="9.5"
                    text-anchor="middle"
                    font-family="Consolas"
                    font-size="9.2"
                    font-weight="700"
                    fill="white"
                    letter-spacing="0"
                >
                    url
                </text>

                <g transform="translate(10.5,19) scale(0.028) translate(-212,-212)" opacity="0.85">
                    <path
                        fill="white"
                        d="M318.15,230.195l77.934-77.937c31.894-31.892,31.894-83.782-0.004-115.674l-12.66-12.66 
                          c-31.893-31.896-83.78-31.896-115.674-0.004l-77.937,77.934c-17.588,17.588-25.457,41.264-23.646,64.311
                          c-23.045-1.813-46.722,6.056-64.308,23.647L23.92,267.748c-31.894,31.889-31.894,83.779,0,115.674l12.664,12.662
                          c31.893,31.893,83.783,31.893,115.674,0l77.935-77.936c17.592-17.59,25.459-41.266,23.647-64.309
                          C276.884,255.654,300.56,247.783,318.15,230.195z
                          M202.653,290.605l-77.936,77.938c-16.705,16.703-43.889,16.703-60.59,0
                          l-12.666-12.666c-16.705-16.701-16.703-43.885,0-60.594l77.936-77.932
                          c14.14-14.141,35.779-16.306,52.226-6.516l-32.302,32.307
                          c-7.606,7.604-7.606,19.938,0,27.541c7.605,7.607,19.937,7.607,27.541,0l32.306-32.303
                          C218.959,254.828,216.795,276.469,202.653,290.605z
                          M238.382,209.169l32.299-32.306c7.608-7.602,7.608-19.935,0-27.538
                          c-7.604-7.61-19.936-7.61-27.541-0.004l-32.303,32.303
                          c-9.791-16.446-7.627-38.087,6.514-52.226l77.935-77.935
                          c16.707-16.707,43.89-16.707,60.594,0l12.664,12.664
                          c16.705,16.705,16.705,43.886,0,60.591l-77.936,77.937
                          C276.468,216.797,254.828,218.959,238.382,209.169z"
                    />
                </g>
            </svg>
        )}
    />
)

export default LinkIcon
